<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Brugere</h1>
    <div class="comp-header__actions">
      <button
        [admRequiresFeatureRole]="roles[Permission.ChargingUserAppInvitationCreate]"
        mat-button
        (click)="dialogService.viewAppInvitationsDialog()"
        type="button">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#smartphone-s"></use></svg>
        OK-app onboarding invitationer
      </button>
      <button [admRequiresFeatureRole]="roles['charging-user.create']" mat-button (click)="dialogService.viewInvitesDialog()" type="button">
        <mat-icon>outgoing_mail</mat-icon>
        Brik inviterede brugere
      </button>
      <button
        mat-button
        [matMenuTriggerFor]="menu"
        mat-flat-button
        type="button"
        [admRequiresFeatureRole]="roles[Permission.ChargingUserCreate]">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#user-add-s"></use></svg>
        <span>Opret bruger</span>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="dialogService.openCreateChargingUserWithAppInvitationModal()">
          <span>Med invitation til OK-app</span>
        </button>
        <button mat-menu-item (click)="dialogService.openCreateIdTagWithInvitationModal()">
          <span>Med brik, med invitation</span>
        </button>
        <button mat-menu-item (click)="dialogService.openCreateIdTagWithoutInvitationModal()">
          <span>Med brik, uden invitation</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div>
    @if (state.focusedChargingUser()) {
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til&nbsp;
        <strong>Bruger : {{ state.focusedChargingUser()?.name }}</strong>
        <button (click)="state.resetFilter()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else {
      <div class="comp-header__queries">
        <adm-text-search
          placeholder="e-mail, tlf, org., briknr. mm."
          (search$)="querySearchInput($event)"
          [searchText]="state.filters().query ?? ''" />

        <adm-org-typeahead
          [initialId]="state.filters().organizationId ?? undefined"
          [resetTrigger]="state.resetOrgFilterSignal()"
          (clearTypeAhead)="clearOrganizations()"
          (itemSelected)="organizationSelected($event)" />

        @if (state.filters().organizationId) {
          @let departmentId = state.filters().departmentId;
          <adm-dep-typeahead
            [organizationId]="state.filters().organizationId"
            [departmentId]="departmentId !== null && departmentId !== undefined ? departmentId.toString() : null"
            (itemSelected)="departmentSelected($event)"
            [resetTrigger]="state.resetDepartmentFilterSignal()" />
        }

        <adm-admin-enum-select-list
          label="Vælg status"
          (enumChanged)="updateChargingUserStatus($event)"
          [enumObject]="chargingUserStatus"
          [translatePipe]="translateChargingUserStatusEnum"
          [initialValue]="state.filters().selectedChargingUserStatus" />

        <adm-admin-enum-select-list
          label="Vælg type"
          (enumChanged)="updateIdTagUserType($event)"
          [enumObject]="idTagUserType"
          [translatePipe]="translateIdTagUserTypeEnum"
          [initialValue]="state.filters().selectedIdTagUserType" />

        <button class="comp-header__reset-button" (click)="state.resetFilter()" mat-stroked-button>Nulstil</button>
      </div>
    }
  </div>
</div>
<div class="comp-main charging-users">
  <ok-card [loading]="state.loading()">
    <ok-expand-list
      [trackBy]="'id'"
      [sort]="state.currentSort()"
      [data]="state.chargingUsersSignal().items"
      [itemTemplate]="chargingUser"
      [configuration]="config()"
      (sortChange)="state.onSortChange($event)">
    </ok-expand-list>
    <mat-paginator
      #paginator
      class="paginator"
      [pageSize]="state.filters().page.pageSize"
      [pageSizeOptions]="state.pagingOptions.pageSizeOptions"
      [pageIndex]="state.filters().page.pageIndex"
      [length]="state.chargingUsersSignal().totalCount"
      (page)="pageSwitch($event)"
      color="accent"
      [disabled]="state.loading()" />
  </ok-card>
</div>

<ng-template #chargingUser let-chargingUserData>
  <ok-card>
    <adm-charging-user-details [chargingUser]="chargingUserData" />
  </ok-card>
</ng-template>

<ng-template #headerColumnStatusTemplate let-chargingUserData>
  <div class="status-template">
    <span>
      @if (chargingUserData.chargingUserStatus.toString() === chargingUserStatusEnum[chargingUserStatusEnum.Pending]) {
        <svg class="icon-24" aria-hidden="false" [matTooltip]="chargingUserData.chargingUserStatus | translateChargingUserStatusEnum">
          <use href="assets/images/ok-icons-sprite.svg#state-waiting"></use>
        </svg>
      }
      @if (chargingUserData.chargingUserStatus.toString() === chargingUserStatusEnum[chargingUserStatusEnum.Active]) {
        <svg class="icon-24" aria-hidden="false" [matTooltip]="chargingUserData.chargingUserStatus | translateChargingUserStatusEnum">
          <use href="assets/images/ok-icons-sprite.svg#state-available"></use>
        </svg>
      }
      @if (chargingUserData.chargingUserStatus.toString() === chargingUserStatusEnum[chargingUserStatusEnum.Deleted]) {
        <svg class="icon-24" aria-hidden="false" [matTooltip]="chargingUserData.chargingUserStatus | translateChargingUserStatusEnum">
          <use href="assets/images/ok-icons-sprite.svg#state-faulted"></use>
        </svg>
      }
      @if (chargingUserData.chargingUserStatus.toString() === chargingUserStatusEnum[chargingUserStatusEnum.Created]) {
        <svg class="icon-24" aria-hidden="false" [matTooltip]="chargingUserData.chargingUserStatus | translateChargingUserStatusEnum">
          <use href="assets/images/ok-icons-sprite.svg#state-paused"></use>
        </svg>
      }
    </span>

    @if (chargingUserData.mokUserNumber) {
      <span>
        <a
          [routerLink]="['/ok-app-emulator']"
          [queryParams]="{
            mapSearchInputType: 'mokUserNumber',
            query: chargingUserData.mokUserNumber,
          }"
          target="_blank"
          class="inline">
          <svg class="icon-24" aria-hidden="false" [matTooltip]="chargingUserData | translateChargingUserAppUser">
            <use href="assets/images/ok-icons-sprite.svg#smartphone-s"></use>
          </svg>
        </a>
      </span>
    }
    @if (!chargingUserData.mokUserNumber && chargingUserData.deviceId) {
      <span>
        <a
          [routerLink]="['/ok-app-emulator']"
          [queryParams]="{
            mapSearchInputType: 'deviceId',
            query: chargingUserData.deviceId,
          }"
          class="inline">
          <svg class="icon-24" aria-hidden="false" [matTooltip]="chargingUserData | translateChargingUserAppUser">
            <use href="assets/images/ok-icons-sprite.svg#smartphone-s"></use>
          </svg>
        </a>
      </span>
    }
    @if (!chargingUserData.mokUserNumber && !chargingUserData.deviceId && chargingUserData.appInvitationHasBeenSent) {
      <span>
        <svg class="icon-24 no-app-access" aria-hidden="false" [matTooltip]="chargingUserData | translateChargingUserAppUser">
          <use href="assets/images/ok-icons-sprite.svg#smartphone-s"></use>
        </svg>
      </span>
    }

    <span>
      <svg
        class="icon-24"
        [class.not-visible]="chargingUserData.idTagCount === 0"
        aria-hidden="false"
        [matTooltip]="'Aktive ladebrikker' + (chargingUserData.idTagCount > 0 ? ': ' + chargingUserData.idTagCount : '')">
        <use href="assets/images/ok-icons-sprite.svg#token-s"></use>
      </svg>
    </span>
  </div>
</ng-template>

<ng-template #columnOrganizationTemplate let-chargingUserData>
  <a class="emulator-link" [routerLink]="['/organizations']" [queryParams]="{ organizationId: chargingUserData.organizationId }">
    {{ chargingUserData.organizationName }}

    @if (chargingUserData.departmentId > 0) {
      <span class="app-department-link">
        <mat-icon class="app-department-icon">subdirectory_arrow_right</mat-icon>
        {{ chargingUserData.departmentName }}
      </span>
    }
  </a>
</ng-template>

<ng-template #columnCreatedTemplate let-chargingUserData>
  <span>{{ chargingUserData.created | date: 'short' }}</span>
</ng-template>

<ng-template #columnUpdatedTemplate let-chargingUserData>
  <span>{{ chargingUserData.updated | date: 'short' }}</span>
</ng-template>

<ng-template #columnCompanyCarTemplate let-chargingUserData>
  <span>{{ chargingUserData.idTagUserType | translateIdTagUserTypeEnum }}</span>
</ng-template>

<ng-template #headerColumnStatusTemplate let-chargingUserData>
  <svg class="icon-24" aria-hidden="false" [matTooltip]="'Status for brugeren'">
    <use href="assets/images/ok-icons-sprite.svg#state-waiting"></use>
  </svg>
</ng-template>

<ng-template #columnAccessGroupTemplate let-chargingUserData>
  <div class="flex">
    {{ chargingUserData.accessGroupCount }}
    @if (chargingUserData.timeLimitedAccessGroupCount > 0) {
      <mat-icon
        class="margin--left-xs cursor-help"
        matTooltip="En eller flere adgangsgrupper har en tidsbegrænset tilknytning til brugeren."
        >update</mat-icon
      >
    }
  </div>
</ng-template>
